<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isServiceManager()">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>Add Item to Inventory | Purchase Manager</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br />
                <!-- main row for all icons  -->
                <div class="col-lg-12">
                    <div class="card card-primary card-outline">
                        <div class="card-header">
                            Add Item
                            <div class="card-tools">
                                <!-- Collapse Button -->
                                <button class="btn btn-danger" @click="slMdl">
                                    <i class="fa fa-search"></i> Sl/IMEI No.
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-tool"
                                    data-card-widget="collapse"
                                >
                                    <i class="fas fa-minus"></i>
                                </button>
                            </div>
                        </div>
                        <div class="card-body overflow-auto">
                            <form @submit.prevent="addItem">
                                <div class="form-group">
                                    <label>Item Name</label>
                                    <input
                                        type="text"
                                        placeholder="Enter item name"
                                        v-model="form.item_name"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Item Code</label>
                                    <input
                                        type="text"
                                        placeholder="Enter the item code"
                                        v-model="form.item_code"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Bill No.</label>
                                    <input
                                        type="text"
                                        placeholder="Enter the bill no"
                                        v-model="form.bill_no"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>IMEI No.</label>
                                    <input
                                        type="text"
                                        placeholder="Enter the IMEI no"
                                        v-model="form.imei_no"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Sl No.</label>
                                    <input
                                        type="text"
                                        placeholder="Enter the Sl. no"
                                        v-model="form.sl_no"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Room</label>
                                    <input
                                        type="text"
                                        placeholder="Enter the room"
                                        v-model="form.room"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Shelf</label>
                                    <input
                                        type="text"
                                        placeholder="Enter the shelf"
                                        v-model="form.shelf"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Rack</label>
                                    <input
                                        type="text"
                                        placeholder="Enter the rack"
                                        v-model="form.rack"
                                        class="form-control"
                                    />
                                </div>
                                <div class="form-group">
                                    <label>MOP</label>
                                    <input
                                        type="number"
                                        placeholder="Enter the MOP"
                                        v-model="form.mop"
                                        class="form-control"
                                        min="1"
                                        readonly
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Landing</label>
                                    <input
                                        type="number"
                                        placeholder="Enter the item charge"
                                        v-model="form.item_charge"
                                        class="form-control"
                                        min="0"
                                    />
                                </div>
                                <div class="form-group">
                                    <button
                                        class="btn btn-primary"
                                        type="submit"
                                    >
                                        Add
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div class="card-footer"></div>
                    </div>
                </div>
                <!-- row end -->
            </section>
            <!-- /.content -->

            <div
                class="modal fade bd-example-modal-lg"
                tabindex="-1"
                role="dialog"
                id="slModal"
            >
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                Search Using Sl\IMEI No.
                            </h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="col-sm-12">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <input
                                                type="text"
                                                placeholder="Enter the SL/IMEI number"
                                                v-model="imei"
                                                class="form-control"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <button
                                                class="btn btn-danger"
                                                @click="imeiSearch"
                                            >
                                                Search ERP for Item
                                            </button>
                                        </div>
                                    </div>
                                    <br />
                                    <div class="col-sm-12">
                                        <div class="form-group">
                                            <span
                                                class="right badge badge-success"
                                                >{{ search_status }}</span
                                            >
                                        </div>
                                    </div>
                                    <br />
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Choose Item:</label>
                                        <v-select
                                            v-model="item"
                                            class="form-control"
                                            type="text"
                                            label="ITEM_NAME"
                                            :options="items"
                                            :reduce="(items) => items.ITEM_CODE"
                                            placeholder="Select APX ITEM"
                                            :value="(items) => items.ITEM_CODE"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            @click="selectItem"
                                            data-dismiss="modal"
                                        >
                                            Select
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isServiceManager()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        console.log("Component mounted.");
    },

    created() {
        //this.getBranches();
    },

    data() {
        return {
            form: new Form({
                bill_no: "",
                imei_no: "",
                sl_no: "",
                item_name: "",
                item_code: "",
                branch: "",
                room: "",
                shelf: "",
                rack: "",
                item_charge: "",
                mop: "",
            }),
            imei: "",
            branches: [],
            items: [],
            search_status: "",
            item: "",
        };
    },

    methods: {
        slMdl() {
            this.search_status = "";
            $("#slModal").modal("show");
        },
        imeiSearch() {
            toast.fire({
                icon: "warning",
                title: "Searching!!!",
            });
            this.search_status = "Searching...";
            axios
                .post("/api/pmSlSearch", { imei: this.imei })
                .then((response) => {
                    this.items = response.data;
                    toast.fire({
                        icon: "success",
                        title: "Search Complete",
                    });
                    this.search_status = "Search Complete!";
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Search Failed",
                    });
                    this.search_status = "Search Complete!";
                });
        },

        selectItem() {
            var item = this.items.find((c) => c.ITEM_CODE == this.item);
            this.form.item_name = item.ITEM_NAME;
            this.form.item_code = item.ITEM_CODE;
            this.form.sl_no = item.SERIAL_NO;
            this.form.imei_no = item.SERIAL_NO;
            this.form.mop = item.BRANCH_DEFAULT_PRICE;

            $("#slModal").modal("hide");
        },

        addItem() {
            this.form
                .post("/api/createItemSM")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Added",
                        });
                        this.form.reset();
                    } else
                        toast.fire({
                            icon: "error",
                            title: "Failed",
                        });
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },
    },
};
</script>
